import { render, staticRenderFns } from "./SiteIcon.vue?vue&type=template&id=ed73d692&scoped=true"
import script from "./SiteIcon.vue?vue&type=script&lang=js"
export * from "./SiteIcon.vue?vue&type=script&lang=js"
import style0 from "./SiteIcon.vue?vue&type=style&index=0&id=ed73d692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed73d692",
  null
  
)

export default component.exports